import { AccessibilityButton } from '@diversioteam/diversio-ds'
import React from 'react'

import * as S from './resultsSummaryCard.styles'
import { ResultsSummaryCardProps } from './resultSummaryCard.types'

export const ResultsSummaryCard = ({
    isColorBlindModeEnabled,
    handleColorBlindModeToggle,
    title = 'Results Summary',
    totalResponses,
}: ResultsSummaryCardProps) => {
    return (
        <S.ResultsSummaryCard>
            <S.SummaryTitle>
                {totalResponses} {title}
            </S.SummaryTitle>
            <S.SummaryTooltip>
                <AccessibilityButton
                    descriptionText="Add textures to charts to make them easier to tell apart."
                    switchLabel="Change chart colors"
                    label="Color blind?"
                    placement="right-start"
                    checked={isColorBlindModeEnabled}
                    onSwitchToggle={handleColorBlindModeToggle}
                />
            </S.SummaryTooltip>
        </S.ResultsSummaryCard>
    )
}
